import axios from 'axios';

const useAddressService = (cep: string) =>
  axios.get(`https://viacep.com.br/ws/${cep}/json`);

export default useAddressService;
